import React from "react";
import TabNavigation from "@/components/TabNavigation";
import { useTranslationContext } from "@/context/TranslationContext";
import { contentModeration as tr } from "@/constants/translation/contentModeration.translation";
import { contentModeration as moderationRoutes } from "@/libs/routes";

const SECTION_KEYS = ["groups", "communities", "activities", "feedPosts"];

/**
 * The four Content Moderation sub tabs (Groups | Communities | Activities | Feed Posts), shown at the top of every
 * moderation list and view page - same look as the Settings tabs. A tab stays active on its view pages too.
 */
const ContentModerationTabs = () => {
  const t = useTranslationContext();

  const tabs = SECTION_KEYS.map((key) => ({
    label: t(tr.sections[key].heading),
    path: moderationRoutes[key].list,
    isPattern: true,
    childTabPaths: [`${moderationRoutes[key].list.replace(/\/list$/, "")}/*`],
  }));

  return (
    <div className="content-moderation-tabs">
      <TabNavigation tabs={tabs} />
    </div>
  );
};

export default ContentModerationTabs;
